import type { Tables } from "@msuite/utils/types";
import type { ReactNode } from "react";
import { Lightbox } from "../lightbox";
import type { GetFileAnnotations, SaveFileAnnotations } from "../lightbox/shared";
import type { UseRemoteFileUrl } from "../types";

/** Props Interface */
interface FileInspectorModalImageItemProps {
	file: Tables<"files">;
	useRemoteFileUrl: UseRemoteFileUrl;
	getAnnotations?: GetFileAnnotations;
	onSaveAnnotations?: SaveFileAnnotations;
	hasAnnotations?: boolean;
	children: ReactNode;
}

export function FileInspectorModalImageItem({
	file,
	useRemoteFileUrl,
	getAnnotations,
	onSaveAnnotations,
	hasAnnotations,
	children,
}: FileInspectorModalImageItemProps) {
	/** Query */
	const { signedUrl } = useRemoteFileUrl(file);

	/** Render */
	return (
		<Lightbox.Item
			src={signedUrl}
			width={file.width}
			height={file.height}
			contentType={file.contentType}
			fileName={file.fileName}
			id={file.id}
			getAnnotations={getAnnotations}
			onSaveAnnotations={onSaveAnnotations}
			hasAnnotations={hasAnnotations}
		>
			{children}
		</Lightbox.Item>
	);
}
